module.exports = __webpack_public_path__ + "img/5.8cc093a9.jpg";